import { render, staticRenderFns } from "./lift.vue?vue&type=template&id=fe062aac&scoped=true"
import script from "./lift.vue?vue&type=script&lang=js"
export * from "./lift.vue?vue&type=script&lang=js"
import style0 from "./lift.vue?vue&type=style&index=0&id=fe062aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe062aac",
  null
  
)

export default component.exports